import React, { useEffect, useState } from "react"
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar"
import {
  Grid,
  withStyles,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core"

import { useStyles } from "../style"
import DialogComponent from "Components/UI/Molecules/Modals/DialogComponent"
import { interfaces } from "service/interfaces"

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    width: "1440px",
  },
}))(TableRow)

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}))(TableCell)

const ButtonVehicle = (props) => {
  const classes = useStyles()
  const { id, handleClose, open } = props
  const [history, setHistory] = useState([])
  const [state, setState] = useState("Buscando resultados")

  useEffect(() => {
    interfaces.configInterface
      .vehicleCompany(id)
      .then((res) => setHistory(res.data))
    setTimeout(() => {
      setState("No se encontraron resultados")
    }, 1000)
  }, [id])

  return (
    <>
      <DialogComponent
        open={open}
        widthLarge="500px"
        handleclose={handleClose}
        title="Vehículos"
        children={
          <div className={classes.table}>
            <Grid item sm={12}>
              <Table>
                <TableBody>
                  {history.length === 0 ? (
                    <div
                      style={{
                        height: "500px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography variant="body1">{state}</Typography>
                    </div>
                  ) : (
                    <div className={classes.tableHeight}>
                      <Table>
                        <TableBody>
                          {history.map((row) => (
                            <StyledTableRow>
                              <StyledTableCell
                                className={classes.stylesTableCell}
                              >
                                <DirectionsCarIcon />
                                <Typography className={classes.descripcion}>
                                  {row.title ? row.title : null}
                                </Typography>
                              </StyledTableCell>
                            </StyledTableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  )}
                </TableBody>
              </Table>
            </Grid>
          </div>
        }
      />
    </>
  )
}

export default ButtonVehicle
